import React from 'react';

import MinisterIcon from '../assets/icons/minister.svg';


const PartnerCard = ({ logo, title, isPlaceholder, link = "https://www.google.com" }) => {

    if (isPlaceholder) {
        return (
            <div className="relative w-[280px] h-[280px] group">
                <div className="absolute inset-0 bg-[#2A2E35]/50 rotate-45 rounded-[45px]">
                    <div className="absolute inset-0 flex items-center justify-center -rotate-45">
                        <p className="text-gray-400 text-lg">Тун удахгүй..</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="relative w-[280px] h-[280px] group cursor-pointer block transition-transform duration-300 hover:scale-105"
        >
        <div className="relative w-[280px] h-[280px] group">
            {/* Rotated background */}
            <div className="absolute inset-0 bg-[#2A2E35]/50 rotate-45 rounded-[45px]">
                {/* Content container (rotated back to normal) */}
                <div className="absolute inset-0 flex flex-col items-center justify-center -rotate-45 p-8">
                    <img
                        src={logo}
                        alt={title}
                        className="w-32 h-32 mb-6 text-yellow-400"
                    />
                    <h3 className="text-center text-white font-medium tracking-wide whitespace-pre-line leading-tight">
                        {title}
                    </h3>
                </div>
            </div>
        </div>
        </a>
    );
};

const Partners = () => {
    const partners = [
        {
            logo: MinisterIcon,
            title: "ХУУЛЬ ЗҮЙ, ДОТООД\nХЭРГИЙН ЯАМ",
            link: "https://mojha.opengov.mn"
        },
        {
            logo: MinisterIcon,
            title: "БОЛОВСРОЛ,\nШИНЖЛЭХ УХААНЫ\nЯАМ",
            link: "https://meds.opengov.mn"
        },
        {
            logo: MinisterIcon,
            title: "ХҮНС, ХӨДӨӨ АЖ АХУЙ,\nХӨНГӨН\nҮЙЛДВЭРЛЭГЧДИЙН\nЯАМ",
            link: "https://mofa.opengov.mn"
        },
        {
            logo: MinisterIcon,
            title: "ХОТ БАЙГУУЛАЛТ,\nБАРИЛГА, ОРОН\nСУУЦЖУУЛАЛТЫН ЯАМ",
            link: "https://mudch.opengov.mn"
        },
        {
            isPlaceholder: true
        }
    ];

    return (
        <div
            className="min-h-screen min-w-screen h-full flex flex-col md:flex-row items-center px-4 md:px-24 py-8 md:py-16 overflow-auto">
            <div className="md:hidden mb-8">
                <h2 className="text-3xl font-bold text-center">
                    ХАМТРАГЧ
                </h2>
            </div>
            <div className="relative flex flex-1">
                {/* Vertical Title for desktop only */}
                <div className="hidden md:block absolute top-1/2 -translate-y-1/2 items-center justify-center">
                    <h2 className="text-4xl font-bold transform -rotate-90 whitespace-nowrap origin-center">
                        ХАМТРАГЧ
                    </h2>
                </div>

                {/* Content Container */}
                <div className="flex-1 md:ml-40"> {/* Space for the rotated header on desktop */}
                    {/* Grid */}
                    <div className="grid w-full grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-24">
                        {partners.map((partner, index) => (
                            <PartnerCard key={index} {...partner} />
                        ))}
                    </div>
                </div>
            </div>
        </div>

    );
};

export default Partners;